var styleDataHash = "163f1980";
const injectCss = () => {
  var css = `@charset "UTF-8";.aw-J1,.glob_fontElementMap{font-family:var(--ricos-font-family,unset)}.s-kQS{align-items:center;color:var(--ricos-settings-text-color,#000);display:flex;font-family:var(--ricos-settings-text-font-family,Madefor,"Helvetica Neue",Helvetica,Arial,メイリオ,meiryo,"ヒラギノ角ゴ pro w3","hiragino kaku gothic pro",sans-serif);font-size:14px;justify-content:center}[dir] .s-kQS{background:transparent;border:0;cursor:pointer;padding:4px}[dir] .s-kQS:hover:not([disabled]){background-color:rgba(var(--ricos-settings-action-color-tuple,var(--ricos-fallback-color-tuple,0,0,0)),.06)}.s-kQS.dQiLt{color:var(--ricos-settings-text-color,var(--ricos-action-color-fallback,#116dff));fill:var(--ricos-settings-text-color,var(--ricos-action-color-fallback,#116dff))}[dir] .s-kQS.dQiLt{background-color:rgba(var(--ricos-action-color-fallback-tuple,2,97,255),.1)}.s-kQS.dQiLt svg{fill:var(--ricos-settings-icons-color,currentColor);color:var(--ricos-settings-icons-color,currentColor)}.s-kQS._9K21M{opacity:.4}[dir] .s-kQS._9K21M{cursor:default}[dir] .s-kQS.IPbB9:not(.dQiLt):hover{background-color:unset}.s-kQS:focus{outline:5px auto Highlight!important;outline:5px auto -webkit-focus-ring-color!important}.vPv4g{align-items:center;display:flex;gap:8px;height:20px;justify-content:center;min-width:20px;position:relative;width:max-content}.vPv4g._8j0RS{height:32px;width:32px}.S8WRZ{align-items:center;display:flex;gap:8px;height:20px;justify-content:center;min-width:20px;position:relative;width:max-content}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
};
injectCss();
var ToolbarButton_default = {
  "fontElementMap": "aw-J1",
  "toolbarButtonWrapper": "s-kQS",
  "active": "dQiLt",
  "disabled": "_9K21M",
  "mobileToolbarButtonWrapper": "IPbB9",
  "toolbarButton": "vPv4g",
  "mobileToolbarButton": "_8j0RS",
  "iconTextWrapper": "S8WRZ"
};
export {
  ToolbarButton_default as default,
  injectCss
};
//# sourceMappingURL=ToolbarButton-scss.js.map
